module.exports = __webpack_public_path__ + "img/604.a8ba2785.jpg";